import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PublicSettingDto } from '../../helper/dto/public-settings.dto';
import { AuthApiService } from '../../services/auth-api.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-index',
    standalone: true,
    imports: [CommonModule, RouterModule, ProgressSpinnerModule],
    templateUrl: './index.component.html'
})
export class IndexComponent implements OnInit {
    oidcEnabled = false;
    oidcForceLogin = false;
    oidcButtonText = '';
    oidcData: PublicSettingDto[] = [];

    showSpinner = false;

    constructor(
        private authService: AuthService,
        private authApiService: AuthApiService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.authApiService.getOIDCData().subscribe({
            next: (data) => {
                this.oidcData = data;

                const oidcButtonText = this.oidcData.find((x: any) => x.key === 'oidc_login_button_text');
                const oidcEnable = this.oidcData.find((x: any) => x.key === 'oidc_enabled');
                const oidcForceLogin = this.oidcData.find((x: any) => x.key === 'oidc_force_login');

                if (oidcEnable && oidcEnable.valueBoolean) {
                    this.oidcEnabled = true;
                }

                if (oidcButtonText && oidcButtonText.value) {
                    this.oidcButtonText = oidcButtonText.value;
                }

                if (oidcForceLogin && oidcForceLogin.valueBoolean) {
                    this.oidcForceLogin = oidcForceLogin.valueBoolean;

                    if (this.oidcEnabled && this.oidcForceLogin) {
                        this.oidcLogin();
                    }
                } else {
                    this.authService.sessionData.subscribe(data => {
                        if (data.isLoggedIn) {
                            if (data.user && data.user.roles && data.user.roles.includes('administration')) {
                                this.router.navigate(['/admin']);
                            } else {
                                this.router.navigate(['/admin']);
                            }
                        } else {
                            this.router.navigate(['/login']);
                        }
                    });
                }
            },
            error: (error) => {
                console.error(error);
                this.showSpinner = false;
            }
        });
    }

    oidcLogin() {
        this.showSpinner = true;
        this.route.queryParams.subscribe(params => {
            const host: string = (window as any)['__env'].apiEndpoint;
            if (params['returnUrl']) {
                window.location.href = `${host}/v1/auth/oidc/login?returnUrl=${params['returnUrl']}`;
            } else {
                window.location.href = `${host}/v1/auth/oidc/login`;
            }
        });
    }
}
